// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

/*
  UMD header generated via modularize.js at 2015-04-02T22:08:31.529Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:base': ['gaTrackEventWrapper'],
  'minted:template/wedding_virality': [],
  'minted:constants': []
})(this, function (m_module, Backbone, _, $, base_module) {

var M = m_module.M;
var gaTrackEventWrapper = base_module.gaTrackEventWrapper;

M.View = M.View || {};
M.View.WeddingVirality = M.View.WeddingVirality || {};

/**
 * @class M.View.WeddingVirality.LogoDescriptionDialog
 *
 * A jQueryUI dialog view explaining why you should print the Minted
 * logo on the back of your card.
 */
M.View.WeddingVirality.LogoDescriptionDialog = Backbone.View.extend({
  tagName: 'div',
  className: 'logoDescriptionDialog',
  template: M.IS_MOBILE_OPTIMIZED ? _.template(M.Template.WeddingVirality.MobileLogoDescriptionDialog) : _.template(M.Template.WeddingVirality.LogoDescriptionDialog),
  designer_template: _.template(M.Template.WeddingVirality.DesignerBlock),

  events: {
    'click .printLogoButton': 'printLogoButtonClicked',
    'click .cancelButton': 'cancelButtonClicked'
  },

  initialize: function() {
    M.required(this.options.body);
    M.required(this.options.buttonText);
    M.required(this.options.title);

    this.$el = $(this.el);
    _.bindAll(this, 'render', 'printLogoButtonClicked', 'cancelButtonClicked');
  },

  render: function() {
    var that = this;

    this.options.designer_block = '';
    if (this.options.designer) {
      this.options.designer_block = this.designer_template(this.options.designer);
    }

    this.$el.html(this.template(this.options));

    this.$el.dialog({
      autoOpen: true,
      dialogClass: 'no-title-with-close weddingViralityPopup',
      draggable: false,
      modal: true,
      resizable: false,
      width: 800,
      zIndex: 2001,
      close: function() {
        that.remove();
      }
    });

    gaTrackEventWrapper(this.options.gaPageCategory,
                        M.GA.TRACK_EVENT_ACTION.BACKER_LOGO_VIEW_DIALOG);

    return this;
  },

  printLogoButtonClicked: function() {
    this.trigger('force_logo');
    this.$el.dialog('close');
  },

  cancelButtonClicked: function() {
    this.trigger('optout_logo');
    this.$el.dialog('close');
  }

});

return {
};

});
